"use client";

import { ChevronDown } from "lucide-react";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

export const AUTH_HELP_PANEL_LINK_CLASSES =
  "inline-flex items-center gap-1 font-semibold text-secondary hover:underline";

interface AuthHelpPanelProps {
  title: string;
  triggerTestId: string;
  contentTestId: string;
  children: React.ReactNode;
}

export function AuthHelpPanel({
  title,
  triggerTestId,
  contentTestId,
  children,
}: AuthHelpPanelProps) {
  return (
    <Collapsible className="rounded-lg border border-line-faint bg-surface-subtle px-3.5 py-3 text-xs text-ink-subtle">
      <CollapsibleTrigger
        className="group flex w-full cursor-pointer items-center justify-between gap-2 text-left text-sm font-semibold text-foreground"
        data-testid={triggerTestId}
      >
        {title}
        <ChevronDown
          className="size-4 shrink-0 text-ink-faint transition-transform group-data-[state=open]:rotate-180"
          aria-hidden="true"
        />
      </CollapsibleTrigger>
      <CollapsibleContent
        className="space-y-2 pt-2"
        data-testid={contentTestId}
      >
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
}
